import React, { useContext, useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { LanguageContext } from "@lib/i18n/LanguageProvider";
import { Helmet } from "react-helmet-async";

type LayoutContextType = {
  setLayoutContext: (title: string) => void;
  setLayoutHeaderImage: (url: string) => void;
  setPageTitle: (pageTitle: string) => void;
  setPageSummary: (pageSummary: string) => void;
  setVideoHelpUrl: (helpUrl: string) => void;
  setShowHeader: (showHeader: boolean) => void;
  setShowSidebar: (showSidebar: boolean) => void;
  setShowSummaryOnMobile: (showSummaryOnMobile: boolean) => void;
};

const Homepage: React.FC = () => {
  const {
    setLayoutContext,
    setLayoutHeaderImage,
    setPageTitle,
    setPageSummary,
    setVideoHelpUrl,
    setShowHeader,
    setShowSidebar,
    setShowSummaryOnMobile,
  } = useOutletContext<LayoutContextType>();

  const { id, guid } = useParams<{ id: string; guid: string }>();
  const { translations = {}, lang = "tr-TR" } = useContext(LanguageContext) || {};

  const [isChatOpen, setIsChatOpen] = useState(false);

  const title = "Firma Adı";
  const summary = "Test Ekranı";
  const helpUrl = "";
  const headerImage = require("../../../../assets/images/header/top-header.png");

  useEffect(() => {
    setPageTitle(title);
    setPageSummary(summary);
    setVideoHelpUrl(helpUrl);
    setShowHeader(true);
    setShowSidebar(false);
    setShowSummaryOnMobile(false);
    setLayoutHeaderImage(headerImage);
  }, [title, summary, helpUrl]);

  return (
    <div className="content-inner container-fluid pb-0">
      <Helmet>
        <title> Test Ekranı</title>
      </Helmet>
      <div className="row">
        <div className="card">
          <div className="card-header">TEST</div>
        </div>
      </div>
      {/* FLOATING CHAT WIDGET */}
      {isChatOpen && (
        <div className="floating-widget">
          <div className="floating-widget-header">
            <span>Destek</span>
            <button onClick={() => setIsChatOpen(false)}>✕</button>
          </div>

          <div className="floating-widget-body">
            <iframe
              src="http://localhost:3000/ChatAI?id=1387&token=3a5f8b6b539f48fe8e31f560b3cf1b7e84cb346e9b584b298df59bc622e5ac3f"
              title="AI Chat"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                display: "block",
              }}
              allow="clipboard-write; microphone"
            />
          </div>
        </div>
      )}

      <button className="floating-widget-button" onClick={() => setIsChatOpen((prev) => !prev)}>
        💬
      </button>

      <style>{`
  .floating-widget-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: none;
    background: #4f46e5;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    z-index: 9999;
    box-shadow: 0 10px 25px rgba(0,0,0,.2);
  }

  .floating-widget {
    position: fixed;
    bottom: 90px;
    right: 20px;
    width: 340px;
    height: 480px;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 20px 40px rgba(0,0,0,.25);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .floating-widget-header {
    height: 48px;
    background: #4f46e5;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    font-weight: 600;
  }

  .floating-widget-header button {
    background: none;
    border: none;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
  }

  .floating-widget-body {
    flex: 1;
    overflow: hidden;
    background: #f9fafb;
  }

  @media (max-width: 480px) {
    .floating-widget {
      right: 10px;
      left: 10px;
      width: auto;
      height: 420px;
    }
  }
`}</style>
    </div>
  );
};

export default Homepage;
